export const GoldDivider = () => (
  <div
    aria-hidden="true"
    className="h-px w-full"
    style={{
      background: 'linear-gradient(to right, transparent, rgba(214,168,74,0.35), transparent)',
    }}
  />
);
